export enum BackupInterval{
    Weekly,
    TwoWeekly,
    Monthly,
}